module.exports = __webpack_public_path__ + "img/banner.62a89213.png";